"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridLoaderId = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Spinner_1 = require("../../Spinner");
const features_1 = require("../features");
exports.gridLoaderId = 'grid-loader';
const GridLoaderWrapper = styled_components_1.default.div `
    display: flex;
    align-items: center;
    justify-content: center;

    ${(props) => {
    if (props.dataLength > 0) {
        return (0, styled_components_1.css) `
                position: absolute;
                top: ${props.headerHeight}px;
                left: 0;
                bottom: 0;
                right: 0;
                background-color: rgba(255, 255, 255, 0.7);
                z-index: 10;
            `;
    }
    return (0, styled_components_1.css) `
            flex-grow: 1;
            padding: 20px 0;
        `;
}}
`;
const GridLoader = () => {
    const { state: { data, headerHeight, isLoading } } = (0, features_1.useGridContext)();
    if (!isLoading) {
        return null;
    }
    return (react_1.default.createElement(GridLoaderWrapper, { "data-selector-id": exports.gridLoaderId, dataLength: data.length, headerHeight: headerHeight },
        react_1.default.createElement(Spinner_1.Spinner, { size: 50 })));
};
exports.default = GridLoader;
//# sourceMappingURL=GridLoader.js.map